<template>
    <widget>
        <div class="meter-overview-card">
            <div class="md-subheading">{{ $tc('phrases.meterDetail', 2) }}</div>
            <div class="meter-overview-detail" v-if="meter!==null && meter.loaded===true">
                <div class="md-layout">
                    <div class="md-layout-item">{{ $tc('words.manufacturer') }}</div>
                    <div
                        class="md-layout-item"
                    >{{ meter.manufacturer.name }} ( {{ meter.manufacturer.website }})
                    </div>
                </div>

                <div class="md-layout">
                    <div class="md-layout-item">{{ $tc('phrases.serialNumber') }}</div>
                    <div class="md-layout-item">{{ meter.serialNumber }}</div>
                </div>
                <div class="md-layout">
                    <div class="md-layout-item">{{ $tc('words.tariff') }}</div>
                    <div class="md-layout-item">
                        <div v-if="editTariff===false">
                            {{ meter.tariff.name }}
                            <span style="cursor: pointer" @click="editTariff = true" v-if="meter.tariff.factor!==2"><md-icon>edit</md-icon></span>
                        </div>
                        <div class="md-layout" v-else>
                            <div class="md-layout-item">
                                <md-field>
                                    <label for="tariff">{{ $tc('words.tariff') }}</label>
                                    <md-select name="tariff" v-model="newTariffId">
                                        <md-option v-for="tariff in tariffService.list"
                                                   :key="tariff.id" :value="tariff.id">
                                            {{ tariff.name }} <small> ({{ moneyFormat(tariff.price) }}) </small>
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                            <md-button class="md-icon-button" @click="updateTariff()">
                                <md-icon class="md-primary">save</md-icon>
                            </md-button>
                            <md-button class="md-icon-button" @click="editTariff=false">
                                <md-icon class="md-accent">cancel</md-icon>
                            </md-button>
                        </div>
                    </div>
                </div>
                <div class="md-layout">
                    <div class="md-layout-item">{{ $tc('phrases.connectionGroup') }}</div>
                    <div class="md-layout-item">
                        <div v-if="!editConnectionGroup">
                            {{ meter.connectionGroup.name }}
                            <span style="cursor: pointer" @click="editConnectionGroup = true"><md-icon>edit</md-icon></span>
                        </div>
                        <div class="md-layout" v-else>
                            <div class="md-layout-item">
                                <md-field>
                                    <label for="connectionGroup">{{ $tc('phrases.connectionGroup') }}</label>
                                    <md-select name="connectionGroup"
                                               v-model="newConnectionGroupId">
                                        <md-option v-for="connectionGroup in connectionGroupService.list"
                                                   :key="connectionGroup.id" :value="connectionGroup.id">
                                            {{ connectionGroup.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                            <md-button class="md-icon-button"
                                       @click="updateConnectionGroup()">
                                <md-icon class="md-primary">save</md-icon>
                            </md-button>
                            <md-button class="md-icon-button" @click="editConnectionGroup=false">
                                <md-icon class="md-accent">cancel</md-icon>
                            </md-button>
                        </div>
                    </div>
                </div>
                <div class="md-layout">
                    <div class="md-layout-item">{{ $tc('phrases.connectionType') }}</div>
                    <div class="md-layout-item">
                        <div v-if="editConnectionType===false">
                            {{ meter.connectionType ? meter.connectionType.name : '-' }}
                            <span style="cursor: pointer" @click="startEditConnectionType"><md-icon>edit</md-icon></span>
                        </div>
                        <div class="md-layout" v-else>
                            <div class="md-layout-item">
                                <md-field>
                                    <label
                                        for="connectionType">{{ $tc('phrases.connectionType') }}</label>
                                    <md-select name="connectionType"
                                               v-model="newConnectionTypeId">
                                        <md-option v-for="connectionType in connectionTypeService.list"
                                                   :key="connectionType.id" :value="connectionType.id">
                                            {{ connectionType.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                                <md-field>
                                    <label for="connectionTypeSubType">{{ $tc('phrases.subConnectionType') }}</label>
                                    <md-select name="connectionTypeSubType"
                                               v-model="newSubConnectionTypeId">
                                        <md-option v-for="subConnectionType in subConnectionTypeService.subConnectionTypes"
                                                   :key="subConnectionType.id" :value="subConnectionType.id">
                                            {{ subConnectionType.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                            <md-button class="md-icon-button"
                                       @click="updateConnectionType()">
                                <md-icon class="md-primary">save</md-icon>
                            </md-button>
                            <md-button class="md-icon-button" @click="editConnectionType=false">
                                <md-icon class="md-accent">cancel</md-icon>
                            </md-button>
                        </div>
                    </div>
                </div>
                <div class="md-layout">
                    <div class="md-layout-item">{{ $tc('phrases.subConnectionType') }}</div>
                    <div class="md-layout-item">
                        <div v-if="editSubConnectionType===false">
                            {{ meter.subConnectionType ? meter.subConnectionType.name : '-' }}
                            <span style="cursor: pointer" @click="startEditSubConnectionType"><md-icon>edit</md-icon></span>
                        </div>
                        <div class="md-layout" v-else>
                            <div class="md-layout-item">
                                <md-field>
                                    <label for="subConnectionType">{{ $tc('phrases.subConnectionType') }}</label>
                                    <md-select name="subConnectionType"
                                               v-model="newSubConnectionTypeId">
                                        <md-option v-for="subConnectionType in subConnectionTypeService.subConnectionTypes"
                                                   :key="subConnectionType.id" :value="subConnectionType.id">
                                            {{ subConnectionType.name }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                            <md-button class="md-icon-button"
                                       @click="updateSubConnectionType()">
                                <md-icon class="md-primary">save</md-icon>
                            </md-button>
                            <md-button class="md-icon-button" @click="editSubConnectionType=false">
                                <md-icon class="md-accent">cancel</md-icon>
                            </md-button>
                        </div>
                    </div>
                </div>
                <div class="md-layout" v-if="isOnlineMeter">
                    <div class="md-layout-item">{{ $tc('words.status') }}</div>
                    <div class="md-layout-item">
                        <md-switch
                            v-model="statusSwitch"
                            @change="changeDeviceStatus"
                            :disabled="switchingStatus"
                            class="data-stream-switch"
                        >
                            <span>{{ statusSwitch ? 'ON' : 'OFF' }}</span>
                        </md-switch>
                    </div>
                </div>
            </div>
        </div>
    </widget>
</template>

<script>
import Widget from '@/shared/widget'
import { TariffService } from '@/services/TariffService'
import { ConnectionTypeService } from '@/services/ConnectionTypeService'
import { ConnectionGroupService } from '@/services/ConnectionGroupService'
import { SubConnectionTypeService } from '@/services/SubConnectionTypeService'
import { MeterService } from '@/services/MeterService'
import { DeviceService } from '@/services/DeviceService'
import { currency } from '@/mixins/currency'
import { notify } from '@/mixins/notify'

export default {
    name: 'Details.vue',
    mixins: [currency, notify],
    components: { Widget },
    props: {
        meter: {
            type: Object
        }
    },
    mounted () {
        this.getTariffs()
        this.getConnectionGroups()
        this.getConnectionTypes()
    },
    data () {
        return {
            editTariff: false,
            newTariffId: null,
            meterService: new MeterService(),
            tariffService: new TariffService(),
            connectionTypeService: new ConnectionTypeService(),
            connectionGroupService: new ConnectionGroupService(),
            subConnectionTypeService: new SubConnectionTypeService(),
            deviceService: new DeviceService(),
            newConnectionGroupId: null,
            newConnectionTypeId: null,
            newSubConnectionTypeId: null,
            editConnectionGroup: false,
            editConnectionType: false,
            editSubConnectionType: false,
            statusSwitch: true,
            switchingStatus: false,
        }
    },
    watch: {
        meter: {
            immediate: true,
            handler (value) {
                this.statusSwitch = (value?.deviceStatus ?? 1) === 1
                if (value?.connectionType?.id) {
                    this.getSubConnectionTypes(value.connectionType.id)
                }
            }
        },
        newConnectionTypeId (connectionTypeId) {
            if (!this.editConnectionType || !connectionTypeId) return
            const currentId = this.meter.connectionType ? this.meter.connectionType.id : null
            if (connectionTypeId !== currentId) {
                this.newSubConnectionTypeId = null
            }
            this.getSubConnectionTypes(connectionTypeId)
        }
    },
    computed: {
        isOnlineMeter () {
            return this.meter?.meterType?.online === 1
        }
    },
    methods: {
        async getTariffs () {
            try {
                await this.tariffService.getTariffs()
            } catch (e) {
                this.alertNotify('error', e.message)
            }
        },
        async getConnectionGroups () {
            try {
                await this.connectionGroupService.getConnectionGroups()
            } catch (e) {
                this.alertNotify('error', e.message)
            }
        },
        async getConnectionTypes () {
            try {
                await this.connectionTypeService.getConnectionTypes()
            } catch (e) {
                this.alertNotify('error', e.message)
            }
        },
        async getSubConnectionTypes (connectionTypeId) {
            try {
                await this.subConnectionTypeService.getSubConnectionTypes(connectionTypeId)
            } catch (e) {
                this.alertNotify('error', e.message)
            }
        },
        async startEditConnectionType () {
            this.newConnectionTypeId = this.meter.connectionType ? this.meter.connectionType.id : null
            this.newSubConnectionTypeId = this.meter.subConnectionType ? this.meter.subConnectionType.id : null
            if (this.newConnectionTypeId) {
                await this.getSubConnectionTypes(this.newConnectionTypeId)
            }
            this.editConnectionType = true
        },
        async startEditSubConnectionType () {
            this.newSubConnectionTypeId = this.meter.subConnectionType ? this.meter.subConnectionType.id : null
            if (this.meter.connectionType && this.meter.connectionType.id) {
                await this.getSubConnectionTypes(this.meter.connectionType.id)
            }
            this.editSubConnectionType = true
        },
        async updateTariff () {
            this.$emit('updated', { id: this.meter.id, tariffId: this.newTariffId })
            this.editTariff = false
        },
        async updateConnectionGroup () {
            this.$emit('updated', {id: this.meter.id, connectionGroupId: this.newConnectionGroupId })
            this.editConnectionGroup = false
        },
        async updateConnectionType () {
            if (!this.newSubConnectionTypeId) {
                this.alertNotify('error', this.$tc('phrases.subConnectionType'))
                return
            }
            this.$emit('updated', { id: this.meter.id, subConnectionTypeId: this.newSubConnectionTypeId })
            this.editConnectionType = false
            this.editSubConnectionType = false
        },
        async updateSubConnectionType () {
            this.$emit('updated', { id: this.meter.id, subConnectionTypeId: this.newSubConnectionTypeId })
            this.editSubConnectionType = false
        },
        async changeDeviceStatus (value) {
            try {
                this.switchingStatus = true
                const updatedDevice = await this.deviceService.updateStatus(this.meter.deviceId, value ? 1 : 0)
                this.meter.deviceStatus = updatedDevice.status
                this.alertNotify('success', this.$t('phrases.successfullyUpdated'))
            } catch (e) {
                this.statusSwitch = !value
                this.alertNotify('error', e.message)
            } finally {
                this.switchingStatus = false
            }
        }
    }
}
</script>

